import { HorseMembershipGroupKey, HorseMembershipItem } from '../models/horse/horse.interface'
import { NumberMembershipGroupKey, NumberMembershipItem } from '../models/users/user.interface'

// Number memberships for users
export const USER_MEMBERSHIP_GROUPS: Record<NumberMembershipGroupKey, NumberMembershipItem[]> = {
  English: [
    { fieldKey: 'userACPS', label: 'ACPS number', icon: '/assets/images/logos/ACPS-logo.png' },
    { fieldKey: 'userAHA', label: 'AHA number', icon: '/assets/images/logos/AHA-logo.png' },
    { fieldKey: 'userAHHS', label: 'AHHS number', icon: '/assets/images/logos/AHHS-logo.png' },
    { fieldKey: 'userARHPA', label: 'ARHPA number', icon: '/assets/images/logos/ARHPA-logo.png' },
    { fieldKey: 'userAMHA', label: 'AMHA number', icon: '/assets/images/logos/AMHA-logo.png' },
    { fieldKey: 'userEVUSA', label: 'EVUSA number', icon: '/assets/images/logos/EVUSA-logo.png' },
    { fieldKey: 'userFEI', label: 'FEI number', icon: '/assets/images/logos/FEI-logo.png' },
    { fieldKey: 'userIALHA', label: 'IALHA number', icon: '/assets/images/logos/IALHA-logo.png' },
    { fieldKey: 'userIFSHA', label: 'IFSHA number', icon: '/assets/images/logos/IFSHA-logo.png' },
    { fieldKey: 'userNSHR', label: 'NSHR number', icon: '/assets/images/logos/NSHR-logo.png' },
    { fieldKey: 'userPFHA', label: 'PFHA number', icon: '/assets/images/logos/PFHA-logo.png' },
    { fieldKey: 'userUPHA', label: 'UPHA number', icon: '/assets/images/logos/UPHA-logo.png' },
    { fieldKey: 'userUSDF', label: 'USDF number', icon: '/assets/images/logos/USDF-logo.png' },
    { fieldKey: 'userUSEA', label: 'USEA number', icon: '/assets/images/logos/USEA-logo.png' },
    { fieldKey: 'userUSEF', label: 'USEF number', icon: '/assets/images/logos/USEF-logo.png' },
    { fieldKey: 'userUSHJA', label: 'USHJA number', icon: '/assets/images/logos/USHJA-logo.png' },
    { fieldKey: 'userWDAA', label: 'WDAA number', icon: '/assets/images/logos/WDAA-logo.png' },
    { fieldKey: 'userWPCSA', label: 'WPCSA number', icon: '/assets/images/logos/WPCSA-logo.png' },
  ],
  Western: [
    { fieldKey: 'userAPHA', label: 'APHA number', icon: '/assets/images/logos/APHA-logo.png' },
    { fieldKey: 'userAQHA', label: 'AQHA number', icon: '/assets/images/logos/AQHA-logo.png' },
    { fieldKey: 'userARHA', label: 'ARHA number', icon: '/assets/images/logos/ARHA-logo.png' },
    { fieldKey: 'userBBR', label: 'BBR number', icon: '/assets/images/logos/BBR-logo.png' },
    { fieldKey: 'userIBRA', label: 'IBRA number', icon: '/assets/images/logos/IBRA-logo.png' },
    { fieldKey: 'userNBHA', label: 'NBHA number', icon: '/assets/images/logos/NBHA-logo.png' },
    { fieldKey: 'userNCHA', label: 'NCHA number', icon: '/assets/images/logos/NCHA-logo.png' },
    { fieldKey: 'userNRCHA', label: 'NRCHA number', icon: '/assets/images/logos/NRCHA-logo.png' },
    { fieldKey: 'userNRHA', label: 'NRHA number', icon: '/assets/images/logos/NRHA-logo.png' },
    { fieldKey: 'userNSBA', label: 'NSBA number', icon: '/assets/images/logos/NSBA-logo.png' },
  ],
  Rodeo: [
    { fieldKey: 'userAPRA', label: 'APRA number', icon: '/assets/images/logos/APRA-logo.png' },
    { fieldKey: 'userIPRA', label: 'IPRA number', icon: '/assets/images/logos/IPRA-logo.png' },
    { fieldKey: 'userPBR', label: 'PBR number', icon: '/assets/images/logos/PBR-logo.png' },
    { fieldKey: 'userPRCA', label: 'PRCA number', icon: '/assets/images/logos/PRCA-logo.png' },
    { fieldKey: 'userWPRA', label: 'WPRA number', icon: '/assets/images/logos/WPRA-logo.png' },
  ],
  College: [
    { fieldKey: 'userIHSA', label: 'IHSA number', icon: '/assets/images/logos/IHSA-logo.png' },
    { fieldKey: 'userNCEA', label: 'NCEA number', icon: '/assets/images/logos/NCEA-logo.png' },
    { fieldKey: 'userNHSRA', label: 'NHSRA number', icon: '/assets/images/logos/NHSRA-logo.png' },
    { fieldKey: 'userNIRA', label: 'NIRA number', icon: '/assets/images/logos/NIRA-logo.png' },
    { fieldKey: 'userNLBR', label: 'NLBR number', icon: '/assets/images/logos/NLBR-logo.png' },
  ],
  Other: [],
  Pegasus: [],
}

// Number memberships for horses
export const HORSE_MEMBERSHIP_GROUPS: Record<HorseMembershipGroupKey, HorseMembershipItem[]> = {
  English: [
    {
      numberKey: 'horseAcpsNumber',
      expiresKey: 'horseAcpsExpiration',
      imageKey: 'horseAcpsImage',
      label: 'ACPS number',
      icon: '/assets/images/logos/ACPS-logo.png',
    },
    {
      numberKey: 'horseAhaNumber',
      expiresKey: 'horseAhaExpiration',
      imageKey: 'horseAhaImage',
      label: 'AHA number',
      icon: '/assets/images/logos/AHA-logo.png',
    },
    {
      numberKey: 'horseAhhsNumber',
      expiresKey: 'horseAhhsExpiration',
      imageKey: 'horseAhhsImage',
      label: 'AHHS number',
      icon: '/assets/images/logos/AHHS-logo.png',
    },
    {
      numberKey: 'horseArhpaNumber',
      expiresKey: 'horseArhpaExpiration',
      imageKey: 'horseArhpaImage',
      label: 'ARHPA number',
      icon: '/assets/images/logos/ARHPA-logo.png',
    },
    {
      numberKey: 'horseAmhaNumber',
      expiresKey: 'horseAmhaExpiration',
      imageKey: 'horseAmhaImage',
      label: 'AMHA number',
      icon: '/assets/images/logos/AMHA-logo.png',
    },
    {
      numberKey: 'horseEvusaNumber',
      expiresKey: 'horseEvusaExpiration',
      imageKey: 'horseEvusaImage',
      label: 'EVUSA number',
      icon: '/assets/images/logos/EVUSA-logo.png',
    },
    {
      numberKey: 'horseFeiNumber',
      expiresKey: 'horseFeiExpiration',
      imageKey: 'horseFeiImage',
      label: 'FEI number',
      icon: '/assets/images/logos/FEI-logo.png',
    },
    {
      numberKey: 'horseIalhaNumber',
      expiresKey: 'horseIalhaExpiration',
      imageKey: 'horseIalhaImage',
      label: 'IALHA number',
      icon: '/assets/images/logos/IALHA-logo.png',
    },
    {
      numberKey: 'horseIfshaNumber',
      expiresKey: 'horseIfshaExpiration',
      imageKey: 'horseIfshaImage',
      label: 'IFSHA number',
      icon: '/assets/images/logos/IFSHA-logo.png',
    },
    {
      numberKey: 'horseNshrNumber',
      expiresKey: 'horseNshrExpiration',
      imageKey: 'horseNshrImage',
      label: 'NSHR number',
      icon: '/assets/images/logos/NSHR-logo.png',
    },
    {
      numberKey: 'horsePfhaNumber',
      expiresKey: 'horsePfhaExpiration',
      imageKey: 'horsePfhaImage',
      label: 'PFHA number',
      icon: '/assets/images/logos/PFHA-logo.png',
    },
    {
      numberKey: 'horseUphaNumber',
      expiresKey: 'horseUphaExpiration',
      imageKey: 'horseUphaImage',
      label: 'UPHA number',
      icon: '/assets/images/logos/UPHA-logo.png',
    },
    {
      numberKey: 'horseUsdfNumber',
      expiresKey: 'horseUsdfExpiration',
      imageKey: 'horseUsdfImage',
      label: 'USDF number',
      icon: '/assets/images/logos/USDF-logo.png',
    },
    {
      numberKey: 'horseUseaNumber',
      expiresKey: 'horseUseaExpiration',
      imageKey: 'horseUseaImage',
      label: 'USEA number',
      icon: '/assets/images/logos/USEA-logo.png',
    },
    {
      numberKey: 'horseUsefNumber',
      expiresKey: 'horseUsefExpiration',
      imageKey: 'horseUsefImage',
      label: 'USEF number',
      icon: '/assets/images/logos/USEF-logo.png',
    },
    {
      numberKey: 'horseUshjaNumber',
      expiresKey: 'horseUshjaExpiration',
      imageKey: 'horseUshjaImage',
      label: 'USHJA number',
      icon: '/assets/images/logos/USHJA-logo.png',
    },
    {
      numberKey: 'horseWdaaNumber',
      expiresKey: 'horseWdaaExpiration',
      imageKey: 'horseWdaaImage',
      label: 'WDAA number',
      icon: '/assets/images/logos/WDAA-logo.png',
    },
    {
      numberKey: 'horseWpcsaNumber',
      expiresKey: 'horseWpcsaExpiration',
      imageKey: 'horseWpcsaImage',
      label: 'WPCSA number',
      icon: '/assets/images/logos/WPCSA-logo.png',
    },
  ],
  Western: [
    {
      numberKey: 'horseAphaNumber',
      expiresKey: 'horseAphaExpiration',
      imageKey: 'horseAphaImage',
      label: 'APHA number',
      icon: '/assets/images/logos/APHA-logo.png',
    },
    {
      numberKey: 'horseAqhaNumber',
      expiresKey: 'horseAqhaExpiration',
      imageKey: 'horseAqhaImage',
      label: 'AQHA number',
      icon: '/assets/images/logos/AQHA-logo.png',
    },
    {
      numberKey: 'horseArhaNumber',
      expiresKey: 'horseArhaExpiration',
      imageKey: 'horseArhaImage',
      label: 'ARHA number',
      icon: '/assets/images/logos/ARHA-logo.png',
    },
    {
      numberKey: 'horseBbrNumber',
      expiresKey: 'horseBbrExpiration',
      imageKey: 'horseBbrImage',
      label: 'BBR number',
      icon: '/assets/images/logos/BBR-logo.png',
    },
    {
      numberKey: 'horseIbraNumber',
      expiresKey: 'horseIbraExpiration',
      imageKey: 'horseIbraImage',
      label: 'IBRA number',
      icon: '/assets/images/logos/IBRA-logo.png',
    },
    {
      numberKey: 'horseNbhaNumber',
      expiresKey: 'horseNbhaExpiration',
      imageKey: 'horseNbhaImage',
      label: 'NBHA number',
      icon: '/assets/images/logos/NBHA-logo.png',
    },
    {
      numberKey: 'horseNchaNumber',
      expiresKey: 'horseNchaExpiration',
      imageKey: 'horseNchaImage',
      label: 'NCHA number',
      icon: '/assets/images/logos/NCHA-logo.png',
    },
    {
      numberKey: 'horseNrchaNumber',
      expiresKey: 'horseNrchaExpiration',
      imageKey: 'horseNrchaImage',
      label: 'NRCHA number',
      icon: '/assets/images/logos/NRCHA-logo.png',
    },
    {
      numberKey: 'horseNrhaNumber',
      expiresKey: 'horseNrhaExpiration',
      imageKey: 'horseNrhaImage',
      label: 'NRHA number',
      icon: '/assets/images/logos/NRHA-logo.png',
    },
    {
      numberKey: 'horseNsbaNumber',
      expiresKey: 'horseNsbaExpiration',
      imageKey: 'horseNsbaImage',
      label: 'NSBA number',
      icon: '/assets/images/logos/NSBA-logo.png',
    },
  ],
  Rodeo: [
    {
      numberKey: 'horseApraNumber',
      expiresKey: 'horseApraExpiration',
      imageKey: 'horseApraImage',
      label: 'APRA number',
      icon: '/assets/images/logos/APRA-logo.png',
    },
    {
      numberKey: 'horseIpraNumber',
      expiresKey: 'horseIpraExpiration',
      imageKey: 'horseIpraImage',
      label: 'IPRA number',
      icon: '/assets/images/logos/IPRA-logo.png',
    },
    {
      numberKey: 'horsePbrNumber',
      expiresKey: 'horsePbrExpiration',
      imageKey: 'horsePbrImage',
      label: 'PBR number',
      icon: '/assets/images/logos/PBR-logo.png',
    },
    {
      numberKey: 'horsePrcaNumber',
      expiresKey: 'horsePrcaExpiration',
      imageKey: 'horsePrcaImage',
      label: 'PRCA number',
      icon: '/assets/images/logos/PRCA-logo.png',
    },
    {
      numberKey: 'horseWpraNumber',
      expiresKey: 'horseWpraExpiration',
      imageKey: 'horseWpraImage',
      label: 'WPRA number',
      icon: '/assets/images/logos/WPRA-logo.png',
    },
  ],
  College: [
    {
      numberKey: 'horseIhsaNumber',
      expiresKey: 'horseIhsaExpiration',
      imageKey: 'horseIhsaImage',
      label: 'IHSA number',
      icon: '/assets/images/logos/IHSA-logo.png',
    },
    {
      numberKey: 'horseNceaNumber',
      expiresKey: 'horseNceaExpiration',
      imageKey: 'horseNceaImage',
      label: 'NCEA number',
      icon: '/assets/images/logos/NCEA-logo.png',
    },
    {
      numberKey: 'horseNhsraNumber',
      expiresKey: 'horseNhsraExpiration',
      imageKey: 'horseNhsraImage',
      label: 'NHSRA number',
      icon: '/assets/images/logos/NHSRA-logo.png',
    },
    {
      numberKey: 'horseNiraNumber',
      expiresKey: 'horseNiraExpiration',
      imageKey: 'horseNiraImage',
      label: 'NIRA number',
      icon: '/assets/images/logos/NIRA-logo.png',
    },
    {
      numberKey: 'horseNlbrNumber',
      expiresKey: 'horseNlbrExpiration',
      imageKey: 'horseNlbrImage',
      label: 'NLBR number',
      icon: '/assets/images/logos/NLBR-logo.png',
    },
  ],
  Other: [],
}
